import React from "react";
import { ChevronLeft, Share } from "lucide-react";

interface InstallWeddnProps {
  onBack: () => void;
}

const InstallWeddn: React.FC<InstallWeddnProps> = ({ onBack }) => {
  return (
    <div className="fixed inset-0 z-[100] bg-[#F9F9F9] font-[glacial] overflow-y-auto">
      {/* Back Button */}
      <button
        onClick={onBack}
        className="absolute top-6 left-6 p-2 hover:bg-gray-100 rounded-full transition-colors"
      >
        <ChevronLeft size={24} className="text-gray-900" />
      </button>

      {/* Content */}
      <div className="flex flex-col items-center justify-between h-full px-6 pt-20 pb-12">
        {/* Phone Image */}
        <div className="mb-8 h-[260px] w-[220px] bg-[#D9D9D9] flex items-end justify-end">
          <img
            src="/images/install-weddn.svg"
            alt="Install Weddn"
            className="w-[190px] h-[250px]"
          />
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-[optima] text-gray-900 text-center mb-3">
          Add weddn to your phone apps
        </h1>

        {/* Description */}
        <p className="text-sm text-gray-500 text-center mb-8 max-w-[340px]">
          Get quick access your guestlist and everything about your upcoming wedding
        </p>

        {/* Instructions */}
        <div className="w-full max-w-[400px] space-y-6 mb-8">
          <div className="flex items-start gap-3">
            <span className="text-gray-900 mt-1">•</span>
            <div className="flex items-center gap-2 flex-1">
              <span className="text-gray-900">Tap on the share</span>
              <Share size={18} className="text-gray-900" />
              <span className="text-gray-900">icon in your browser</span>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <span className="text-gray-900 mt-1">•</span>
            <span className="text-gray-900">
              Select "Add to Home Screen"
            </span>
          </div>

          <div className="flex items-start gap-3">
            <span className="text-gray-900 mt-1">•</span>
            <span className="text-gray-900">
              Follow your browser's instruction on how to install weddn to your apps screen
            </span>
          </div>
        </div>

        {/* Browser Info */}
        <p className="text-sm text-gray-600 text-center mb-4 max-w-[340px] bg-white p-2">
          Available in modern browsers including Safari, Google Chrome, Edge, and Firefox
        </p>

        {/* Support Link */}
        <p className="text-sm text-gray-600 text-center pt-5">
          Need help?{" "}
          <a
            href="/support"
            className="text-gray-900 underline hover:text-gray-700"
          >
            Contact support
          </a>
        </p>
      </div>
    </div>
  );
};

export default InstallWeddn;
